import { FormLabel } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledManagementInfoContainer = styled("div")({
    margin: "20px 0",
    border: "1px solid #dbdbdb",
});

const StyledManagementInfoContainerHeader = styled("div")({
    padding: "10px 12px",
    marginTop: "15px",
    borderBottom: "1px solid #dbdbdb",
    textAlign: "start",
});

const StyledPersonnelContainer = styled("div")({
    display: "flex",
    flexDirection: "column",
    flex: "1 1 0",
    flexWrap: "wrap",
    margin: "0 1vw",
});

const StyledManagementInfoContainerRow = styled("div")({
    padding: "1vh 0px",
    borderTop: "none",
    flex: "1 1 calc(50% - 1vw)",
    borderBottom: "1px solid #dbdbdb",
    "&:last-of-type": {
        marginBottom: "8px",
        borderBottom: "none",
    },
});

const StyledPersonnelRowDiv = styled("div")(({ personExists }) => ({
    color: personExists ? "black" : "grey",
    fontSize: "0.875rem",
    padding: "5px 0px",
}));

const PropertyManagementInformationSnapshot = (props) => {
    const { snapshotPersonnel } = props;
    const sortPersonnelByRole = (snapshot) => {
        const personnelByRole = {};
        const result = [];
        snapshot.forEach((personnel) => {
            const { role, firstName, lastName } = personnel;

            if (role in personnelByRole) {
                personnelByRole[role].push({
                    firstName,
                    lastName,
                });
            } else {
                personnelByRole[role] = [
                    {
                        firstName,
                        lastName,
                    },
                ];
            }
        });
        for (const key in personnelByRole) {
            result.push({ role: key, personnel: personnelByRole[key] });
        }
        return result;
    };
    return (
        <StyledManagementInfoContainer>
            <StyledManagementInfoContainerHeader>
                <div>
                    <div>
                        <h3>Management Information</h3>
                    </div>
                </div>
            </StyledManagementInfoContainerHeader>
            <StyledPersonnelContainer>
                {sortPersonnelByRole(snapshotPersonnel).map((personnelData, i) => {
                    const { role, personnel } = personnelData;

                    return (
                        <StyledManagementInfoContainerRow key={i}>
                            {<FormLabel shrink>{role}</FormLabel>}
                            {personnel.map((personData, personIndex) => {
                                const { firstName, lastName } = personData;
                                const personExists = firstName && lastName;
                                return personExists ? (
                                    <StyledPersonnelRowDiv key={personIndex}>
                                        {`${firstName} ${lastName}`}
                                    </StyledPersonnelRowDiv>
                                ) : (
                                    <StyledPersonnelRowDiv key={personIndex} personExists={personExists}>
                                        No individual found
                                    </StyledPersonnelRowDiv>
                                );
                            })}
                        </StyledManagementInfoContainerRow>
                    );
                })}
            </StyledPersonnelContainer>
        </StyledManagementInfoContainer>
    );
};

export default PropertyManagementInformationSnapshot;
